import React from 'react';
import { Clock, X, Trash2 } from 'lucide-react';

const RecentSearches = ({ 
  recentSearches = [], 
  selectedIndex = -1, 
  onSearchSelect, 
  onClearHistory 
}) => {
  const formatTimeAgo = (timestamp) => {
    const now = Date.now();
    const diff = now - timestamp;
    
    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    
    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days < 7) return `${days}d ago`;
    return 'Over a week ago';
  };

  const handleClearSearch = (e, searchToRemove) => {
    e.stopPropagation();
    // You could implement individual search removal here
    // For now, we'll just prevent the event from bubbling
  };

  if (recentSearches.length === 0) {
    return (
      <div className="px-4 py-8 text-center">
        <Clock className="h-8 w-8 text-gray-300 mx-auto mb-2" />
        <p className="text-gray-500 text-sm">No recent searches</p>
        <p className="text-gray-400 text-xs mt-1">
          Start typing to search drivers, vehicles, and documents
        </p>
      </div>
    );
  }

  return (
    <div className="py-2">
      <div className="flex items-center justify-between px-4 py-2 border-b border-gray-100">
        <div className="flex items-center space-x-2">
          <Clock className="h-4 w-4 text-gray-400" />
          <span className="text-sm font-medium text-gray-700">Recent Searches</span>
        </div>
        {recentSearches.length > 0 && (
          <button
            onClick={onClearHistory}
            className="text-xs text-gray-500 hover:text-red-600 flex items-center space-x-1 transition-colors"
            title="Clear search history"
          >
            <Trash2 className="h-3 w-3" />
            <span>Clear</span>
          </button>
        )}
      </div>
      
      <div className="max-h-64 overflow-y-auto">
        {recentSearches.map((search, index) => (
          <button
            key={`${search.query}-${search.timestamp}`}
            onClick={() => onSearchSelect(search)}
            className={`w-full px-4 py-3 text-left hover:bg-gray-50 focus:bg-gray-50 focus:outline-none transition-colors ${
              selectedIndex === index ? 'bg-blue-50' : ''
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3 flex-1 min-w-0">
                <Clock className="h-4 w-4 text-gray-400 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {search.query}
                  </p>
                  <p className="text-xs text-gray-500 mt-0.5">
                    {formatTimeAgo(search.timestamp)}
                  </p>
                </div>
              </div>
              <button
                onClick={(e) => handleClearSearch(e, search)}
                className="p-1 hover:bg-gray-200 rounded-full transition-colors opacity-0 group-hover:opacity-100 focus:opacity-100"
                title="Remove from history"
              >
                <X className="h-3 w-3 text-gray-400" />
              </button>
            </div>
          </button>
        ))}
      </div>
      
      {recentSearches.length > 5 && (
        <div className="px-4 py-2 border-t border-gray-100 bg-gray-50">
          <p className="text-xs text-gray-500 text-center">
            Showing recent {recentSearches.length} searches
          </p>
        </div>
      )}
    </div>
  );
};

export default RecentSearches;